module.exports = __webpack_public_path__ + "static/media/leadership_boat.cb92d168.webp";